import React, { useCallback, useEffect } from 'react';
import moment, { Moment } from 'moment';
import { useSelector } from 'react-redux';
import { getUserProfileData } from '~/features/dashboard/store/selectors';
import { getUserProfile } from '~/features/dashboard/store/actions.thunks';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { GLOBAL_DISPLAY_FORMAT } from '~/config/formatters';

interface DateFormatProps {
    newDate: Date | string | null | Moment;
    format?: string;
}

export type FormatDateType = string | number | Date | Moment;

export function useDateFormat(format?: string) {
    const dispatch = useThunkDispatch();

    const userProfileResponse = useSelector(getUserProfileData);
    useEffect(() => {
        !userProfileResponse && dispatch(getUserProfile());
    }, [userProfileResponse, dispatch]);

    const formatString = format || userProfileResponse?.dateFormat || GLOBAL_DISPLAY_FORMAT;

    return {
        formatDate: useCallback((date: FormatDateType) => moment(date).format(formatString),[formatString]),
        selectedDateFormat: formatString,
    }
}

export const DateFormat: React.FC<DateFormatProps> = ({ newDate, format }) => {
    const { formatDate } = useDateFormat(format);

    return <>{newDate && formatDate(newDate)}</>;
};
